export const DPI_MULTIPLIER = 300;
export const STANDARD_MAT_REVEAL = 0.125;
export const SHIP_TO_HOME_RESTRICTION_DIMENSIONS = {
  maxDim: 46,
  minDim: 34
};
export const SHIP_TO_HOME_RESTRICTED_SIZE_GROUPS = ["XG", "MG"];

export const IN_STORE_PICKUP_SIZE_GROUPS = ["XG", "MG"];

export const MAT_BOARD_STANDARD = { name: "standard", shortSide: 32, longSide: 40 };
export const MAT_BOARD_OVERSIZED = { name: "oversized", shortSide: 40, longSide: 60 };
export const MAT_BOARD_JUMBO = { name: "jumbo", shortSide: 48, longSide: 72 };

export const MAT_BOARD_SIZES = [MAT_BOARD_STANDARD, MAT_BOARD_OVERSIZED, MAT_BOARD_JUMBO];

export const USABLE_MAT_BOARDS = {
  [MAT_BOARD_STANDARD.name]: [MAT_BOARD_STANDARD.name],
  [MAT_BOARD_OVERSIZED.name]: [MAT_BOARD_OVERSIZED.name, MAT_BOARD_JUMBO.name],
  [MAT_BOARD_JUMBO.name]: [MAT_BOARD_JUMBO.name]
};

export const ACTIVE_PRODUCT_STATUS = "ACTIVE";
export const UNLISTED_PRODUCT_STATUS = "UNLISTED";
export const PURCHASABLE_PRODUCT_STATUSES = [ACTIVE_PRODUCT_STATUS, UNLISTED_PRODUCT_STATUS];

export default {
  DPI_MULTIPLIER,
  STANDARD_MAT_REVEAL,
  IN_STORE_PICKUP_SIZE_GROUPS,
  MAT_BOARD_STANDARD,
  MAT_BOARD_OVERSIZED,
  MAT_BOARD_JUMBO,
  MAT_BOARD_SIZES,
  USABLE_MAT_BOARDS,
  SHIP_TO_HOME_RESTRICTION_DIMENSIONS,
  SHIP_TO_HOME_RESTRICTED_SIZE_GROUPS,
  ACTIVE_PRODUCT_STATUS,
  UNLISTED_PRODUCT_STATUS,
  PURCHASABLE_PRODUCT_STATUSES
};
